/**
 * 123123.125 => 123,123.13
 * @param {String|Number} number
 * @param {Object} options
 * @param {String} [options.sep]
 * @param {String} [options.def]
 * @param {String} [options.prefix]
 * @param {String} [options.suffix]
 * @return {string}
 */
const formatNumber = (number, options = {}) => {
    const {
        sep = ',',
        def = '',
        prefix = '',
        suffix = '',
    } = {...options}

    if ([undefined, '', null].includes(number)) {
        return def
    }

    const segs = `${number}`.split('.')

    if (segs[1]) {
        return [
            prefix,
            // Only format natural parts
            formatNumber(segs[0]),
            // Make round decimals to 2 digits
            (+`0.${segs[1]}`).toFixed(2).replace('0', ''),
            suffix,
        ].join('')
    }

    const chunks = []
    const numbers = `${number}`.split('').reverse()

    for (let i = 0; i < numbers.length; i += 3) {
        chunks.push(numbers.slice(i, i + 3).reverse().join(''))
    }

    return [prefix, chunks.reverse().join(sep), suffix].join('')
}

export default formatNumber